import script from "./RecSelect.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./RecSelect.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./RecSelect.vue?vue&type=style&index=0&id=885e332c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-885e332c"]])

export default __exports__